import * as action from "../reducers/newsReducer";
import axios, { authHeader } from "../../services/HTTPService";
const API_URL = process.env.REACT_APP_API_URL;

export const fetchAll = async (
  dispatch,
  { fieldTofilter, filter, fieldToSort, sortDirection, page, pageSize } = {
    fieldTofilter: "title",
    filter: "",
    fieldToSort: "id",
    sortDirection: "asc",
    page: 1,
    pageSize: 8,
  }
) => {
  dispatch(action.setListLoading(true));

  return axios
    .get(API_URL + `/api/featured-news/backoffice/search`, {
      headers: authHeader(),
      params: {
        fieldTofilter,
        filter,
        fieldToSort,
        sortDirection,
        page,
        pageSize,
      },
    })
    .then(({ data }) => {
      const meta = data?.meta;
      dispatch(action.setNewsList({ data }));
      dispatch(action.setMetadata({ meta }));
      dispatch(action.setListLoading(false));
    })
    .catch((error) => {
      dispatch(
        action.setNewsError({ error: error?.response?.data?.error?.message })
      );
      dispatch(action.setListLoading(false));
    });
};

export const fetchDetails = async (dispatch, id) => {
  return axios
    .get(API_URL + `/api/featured-news/${id}`, { headers: authHeader() })
    .then(({ data }) => {
      dispatch(action.setNewsDetail({ data }));
    })
    .catch((error) => {
      dispatch(
        action.setNewsError({ error: error?.response?.data?.error?.message })
      );
    });
};

export const update = async (dispatch, id, body) => {
  return axios
    .put(API_URL + `/api/featured-news/${id}`, body, { headers: authHeader() })
    .then(({ data }) => {
      dispatch(action.setNewsDetail({ data }));
    })
    .catch((error) => {
      dispatch(
        action.setNewsError({ error: error?.response?.data?.error?.message })
      );
    });
};

export const empty = async (dispatch, id) => {
  return axios
    .put(API_URL + `/api/featured-news/empty/${id}`, { headers: authHeader() })
    .then(async () => {
      await fetchDetails(dispatch, id);
    });
};

export const emptyAndReload = async (dispatch, id, params) => {
  return axios
    .put(API_URL + `/api/featured-news/empty/${id}`, { headers: authHeader() })
		.then(async () => {
			await fetchAll(dispatch, params);
		})
		.catch((error) => {
			dispatch(
				action.setNewsError({ error: error?.response?.data?.error?.message })
			);
		});
};